var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function isApigeeFetchError(errorObject) {
    var apigeeKeys = ['id', 'code', 'title', 'detail'];
    return apigeeKeys.every(function (key) { return key in errorObject; });
}
export var EnhancedError = /** @class */ (function (_super) {
    __extends(EnhancedError, _super);
    function EnhancedError(message, errorObject) {
        var _this = _super.call(this, message) || this;
        _this.errorCode = errorObject === null || errorObject === void 0 ? void 0 : errorObject.errorCode;
        _this.errorDescription = errorObject === null || errorObject === void 0 ? void 0 : errorObject.errorDescription;
        return _this;
    }
    return EnhancedError;
}(Error));
function toEnhancedError(errorObject) {
    if (isApigeeFetchError(errorObject)) {
        var errorCode = errorObject.id, errorDescription = errorObject.detail;
        return new EnhancedError(errorCode, {
            errorCode: errorCode,
            errorDescription: errorDescription,
        });
    }
    return new EnhancedError(errorObject.errorCode, errorObject);
}
export var isResponseContentValid = function (response) {
    // a status of 204 is No Content, so there will be no payload to return
    // (response.json() would fail) Also, keepAlive may return a 200 with
    // content-length of 0. If .json() is called on this response, an error will
    // be thrown.
    var contentLength = response.headers.get('Content-Length');
    return response.status !== 204 && contentLength !== '0';
};
export var isPayloadOnlyErrors = function (payload) {
    // guards against the server returning a null payload for a 200 response
    var errors = (payload === null || payload === void 0 ? void 0 : payload.errors) || [];
    return !!errors.length && Object.keys(payload).length === 1;
};
export var badResponse = 'Your request could not be processed. Please try again.';
var badResponseError = new EnhancedError(badResponse);
export var checkForErrorsObject = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, errorObject, e_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ((_a = response.json) === null || _a === void 0 ? void 0 : _a.call(response))];
            case 1:
                payload = _c.sent();
                errorObject = (_b = payload === null || payload === void 0 ? void 0 : payload.errors) === null || _b === void 0 ? void 0 : _b[0];
                if (!errorObject)
                    throw badResponseError;
                throw toEnhancedError(errorObject);
            case 2:
                e_1 = _c.sent();
                if (e_1 === null || e_1 === void 0 ? void 0 : e_1.errorCode)
                    throw e_1;
                else
                    throw badResponseError;
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var handleResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, errorObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!response.ok) {
                    return [2 /*return*/, checkForErrorsObject(response)];
                }
                if (!isResponseContentValid(response)) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 1:
                payload = _a.sent();
                if (isPayloadOnlyErrors(payload)) {
                    errorObject = payload.errors[0];
                    throw toEnhancedError(errorObject);
                }
                return [2 /*return*/, payload];
        }
    });
}); };
//# sourceMappingURL=handleResponse.js.map